import Vue from 'vue'
// import webconfig from '../../../public/webconfig.js'
import bisApi from './bis'

const api = Object.freeze({
  // eslint-disable-next-line no-undef
  bis: bisApi(window.webconfig.bis.api)
})

Object.defineProperty(Vue.prototype, '$$api', {
  get () {
    return api
  }
})

export default api
